// Types related to Applications

export enum ApplicationStatus {
  ACTIVATED = "ACTIVATED",
  INACTIVATED = "INACTIVATED"
}

export enum ApplicationVendor {
  WEB = "WEB",
  TELEGRAM = "TELEGRAM",
  TEAMS = "TEAMS",
  OMNI_CHAT = "OMNI_CHAT",
  WHATTSAPP = "WHATTSAPP",
  TWILLIO = "TWILLIO",
  SMARTERS = "SMARTERS",
  ZZAP = "ZZAP",
  CHATGURU = "CHATGURU"
}

export enum ParameterType {
  INSTRUCTION_TEXT = "INSTRUCTION_TEXT",
  CHARACTER_LIMIT = "CHARACTER_LIMIT",
  PHONE_NUMBER = "PHONE_NUMBER",
  TELEGRAM_BOT_ID = "TELEGRAM_BOT_ID",
  APPLICATION_KEY = "APPLICATION_KEY",
  TELEGRAM_API_TOKEN = "TELEGRAM_API_TOKEN",
  PAYMENT_GATEWAY_STATEMENT_DESCRIPTION = "PAYMENT_GATEWAY_STATEMENT_DESCRIPTION",
  PAYMENT_GATEWAY_STATEMENT_DESCRIPTION_SUFFIX = "PAYMENT_GATEWAY_STATEMENT_DESCRIPTION_SUFFIX",
  MICROSOFT_APP_ID = "MICROSOFT_APP_ID",
  MICROSOFT_APP_PASSWORD = "MICROSOFT_APP_PASSWORD",
  MICROSOFT_APP_TYPE = "MICROSOFT_APP_TYPE",
  MICROSOFT_APP_TENANT_ID = "MICROSOFT_APP_TENANT_ID",
  OMNI_CHAT_API_KEY = "OMNI_CHAT_API_KEY",
  OMNI_CHAT_API_SECRET = "OMNI_CHAT_API_SECRET"
}

export interface ApplicationDto {
  id?: string;
  identifier?: string;
  name?: string;
  status?: ApplicationStatus;
  vendor?: ApplicationVendor;
  created_at?: string;
  updated_at?: string;
}

export interface ParameterDto {
  id?: string;
  applicationId?: string;
  type?: ParameterType;
  content?: string;
  created_at?: string;
  updated_at?: string;
}

export interface SystemMessageDto {
  id?: string;
  message?: string;
  application_id?: string;
  user_status?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  version?: number;
  is_active?: boolean;
  // Novos campos conforme API
  temperature?: number;
  tools?: string[];
  system_message?: string;
  system_media?: string;
  system_deferred_message?: string;
  user_message?: string | null;
  provider_name?: string;
  model_name?: string | null;
  with_rag?: boolean;
}

export interface PromptParameterDto {
  name: string;
  description?: string;
  example?: string;
  data_type?: string;
  is_required?: boolean;
  category?: string;
}

// Interface alternativa para uso com endpoints que retornam apenas array de strings
export type PromptParameterSimpleDto = string[];

export interface EmbeddingDto {
  id?: string;
  text?: string;
  vector?: number[];
  application_id?: string;
  created_at?: string;
  updated_at?: string;
  metadata?: Record<string, any>;
}

export interface ListEmbeddingDto {
  data: EmbeddingDto[];
  current_page: number;
  total_pages: number;
  total_items: number;
}

export interface ListApplicationDto {
  data: ApplicationDto[];
  current_page: number;
  total_pages?: number;
  total_items?: number;
}

export enum ToolStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEPRECATED = "DEPRECATED"
}

export enum ToolType {
  API = "API",
  WEBHOOK = "WEBHOOK",
  FUNCTION = "FUNCTION",
  INTEGRATION = "INTEGRATION",
  AUTOMATION = "AUTOMATION"
}

export interface FileNode {
  id: string;
  name: string;
  type: 'file' | 'folder';
  content?: string;
  language?: string;
  children?: FileNode[];
  path: string;
}

export interface ToolDto {
  id?: string;
  name: string;
  description?: string;
  type: ToolType;
  status: ToolStatus;
  endpoint?: string;
  method?: string;
  headers?: Record<string, string>;
  parameters?: Record<string, any>;
  script?: string;
  files?: FileNode[];
  application_id?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  version?: number;
}

export interface ListToolDto {
  data: ToolDto[];
  current_page: number;
  total_pages?: number;
  total_items?: number;
}